import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useAppDispatcher, useAppSelector } from 'src/redux/store';
import { getNextAvaulableEmployeeNumber } from 'src/redux/slices/employees';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LoadingScreen } from 'src/components/loading-screen';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import EmployeeNewEditForm from '../employee-new-edit-form';

export default function EmployeeCreateView() {
  const settings = useSettingsContext();

  const dispatch = useAppDispatcher();

  const { status, error, employeeNumber } = useAppSelector((state) => state.employees);

  useEffect(() => {
    dispatch(getNextAvaulableEmployeeNumber());
  }, [dispatch]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to generate next available employee number"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.employees.root}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Employees
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new employee"
        links={[
          {
            name: 'Employees',
            href: paths.dashboard.employees.root,
          },
          { name: 'Create a new employee' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <EmployeeNewEditForm employeeNumber={employeeNumber} />
    </Container>
  );
}
